import React, { Component, useState, useEffect } from "react";
import { login, page, ContentDetails, RelatedContent, GetPlayurl } from "../../Model/Content"; //Include Home
import { CheckUser, getGeoInfo } from "../../Model/Users";
import { isMobile } from "react-device-detect";
import VideoPlayerHLS from "../../components/vidjs/mainPlayer";
import VideoPlayer from "react-awesome-player";
import videojs from "video.js";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import Slider from "react-slick";
import videojsqualityselector from "videojs-hls-quality-selector";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { MainDetails } from "./MainDetails";
import BarLoader from "react-spinners/BarLoader";
import {
  BrowserRouter as Router,
  Routes,
  useParams,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import {
  SVGIcons,
  ImgIcons,
  VirsionCheck,
  Appsflyer,
  branchIO,
} from "../../Helpers/Common";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

var options = {};
function onVideoPlay(player) { }
function onPlayerReady(player) {
  var player = videojs("my-player");
  var options = {};

  var player = videojs("my-player", options, function onPlayerReady() {
    videojs.log("Your player is ready!");
    this.play();
    this.on("ended", function () {
      videojs.log("Awww...over so soon?!");
    });
  });

  var videojs = require("video.js");

  require("videojs-hls-quality-selector");

  var player = videojs("my-video");

  player.hlsQualitySelector({
    displayCurrentQuality: true,
  });

  return player;
}

export function Details(props) {
  var player = {};
  const playerRef = React.useRef();
  const [contentdata, setContent] = useState(0);
  const [dataloaded, setDataloaded] = useState(0);
  const [RelatedContentdata, setRelatedcontent] = useState(0);
  const [PlayURLbtn, setPlayURLbtn] = useState(0);
  const [PlayURLbtndata, setPlayURLbtndata] = useState(0);
  const [MainDetailsp, setMainDetailsp] = useState(true);
  const [subscribeduser, setsubscribeduser] = useState(false);
  const [showmodel, setshowmodel] = useState(undefined);
  const { content_slug } = useParams();
  const navigate = useNavigate();
  /*---------------*/
  const getData = () => {
    let country = ""
    getGeoInfo().then((rescountry) => {
      localStorage.setItem("country", rescountry)
      ContentDetails(content_slug, rescountry).then((res) => {
        let dataContent = JSON.parse(res.data);
        setContent(dataContent);
        CheckUser().then((res) => {
          if (res?.user_data?.is_subscribed == true) {
            setsubscribeduser(true);
          }
        });
        if (res.data.message && res.data.message == "session_expired") {
          // navigate("/createaccount");
        }
        if (JSON.parse(res.data).body) {

          if (JSON.parse(JSON.parse(res.data).body).message == "Genres Not Found") {
            navigate('/404')
          }
        }
        var content_details = JSON.parse(res.data);

        // Appsflyer("Content Viewed", {
        //   Title: content_details.content?.title,
        //   Contentid: content_details.content?.ID,
        // });
        // branchIO("Content Viewed", {
        //   Title: content_details.content?.title,
        //   Contentid: content_details.content?.ID,
        // })
        if (content_details.content?.ID) {
          var Request = {
            content_id: content_details.content.ID,
            x_country: rescountry
          };
          RelatedContent(Request).then((response) => {
            var Postdata = {
              content_id: content_details.content.ID,
              content_type: content_details.content.type,
            };

            if (response) {
              var RelatedContent = JSON.parse(response.data.message.body);
              setDataloaded(true);
              // setContent(res);
              setRelatedcontent(RelatedContent);
            } else {
              setDataloaded(false);
            }
          });
        } else {
          setDataloaded(false);
        }
      });
    });
  };
  /*---------------*/
  useEffect(() => {
    getData();
    // VirsionCheck().then((vcheckres) => {
    // });
  }, []);

  function Showmodels() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
    setshowmodel(true);
  }
  function Closemodel() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
    setshowmodel(false);
  }
  function PlayURL(content_id, content_type) {
    setMainDetailsp(false);
    setPlayURLbtn(true);
  }

  function closePlayer() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
  }
  if (PlayURLbtn) {
    if (PlayURLbtndata.data.subtitles) {
      var content = PlayURLbtndata.data;
      var subtitles = [];
      if (content.subtitles) {
        if (content.subtitles.length > 0) {
          for (var i in content.subtitles) {
            var tempObj = {};
            tempObj["srclang"] = content.subtitles[i]["lang"];
            tempObj["label"] = content.subtitles[i]["lang"];
            tempObj["src"] = content.subtitles[i]["file"];
            subtitles.push(tempObj);
          }
        }
      }
    }
    var videoURL = contentdata;
    if (videoURL.statusCode == "403") {
      return <p>No content found</p>;
    }
    var content = videoURL.content;
  }

  if (dataloaded == false) {
    // return <div className="loader"></div>;
    return (
      <div className="loader">
        <BarLoader color="#ff000f" />
      </div>
    );
  } else {
    var jsoncontent = contentdata;

    return (
      <>
        {/* <Helmet>
        <title>DocuBay-{jsoncontent.content.title}</title>
        <meta name="description" content="" />
        <meta name="keywords" content={jsoncontent.content.genres} />
        <meta property="og:title" content={jsoncontent.content.title} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={jsoncontent.content?.thumbnail_image2?.original} />
        <link rel="canonical" content={jsoncontent.content.title} />
      </Helmet> */}

        {PlayURLbtn ? (
          <VideoPlayerHLS
            data={PlayURLbtndata.data.url.video_url}
            subtitles={{ subtitles }}
            post={content.thumbnail_image2}
            content_slug={content_slug}
            functionclose={closePlayer}
            subscribed={subscribeduser}
            skip={JSON.parse(contentdata.data).content.user_duration}
            showmodel={Showmodels}
            ContentDetails={JSON.parse(contentdata.data).content}
          />
        ) : null}

        {MainDetailsp ? (
          <MainDetails
            contentdata={contentdata}
            PlayURL={PlayURL}
            RelatedContentdata={RelatedContentdata}
            showmodel={showmodel}
            Closemodel={Closemodel}
          />
        ) : null}
      </>
    );
  }
}
